function openDrawer() {
    $('#storeOverlay').addClass('active');
    $('#storeDrawer').addClass('open');
    $('body').css('overflow', 'hidden');
    $('#storeList .store-card').css('animation', 'none').each(function (i) {
      var $el = $(this);
      setTimeout(function () {
        $el.css('animation', '');
      }, 10);
    });
  }

  function closeDrawer() {
    $('#storeOverlay').removeClass('active');
    $('#storeDrawer').removeClass('open');
    $('body').css('overflow', '');
  }
  
$(document).ready(function () {

  const $optionItems   = $('.pdp-option-item');
  const $variantCards  = $('.pdp-variant-card');
  const $selectedLabel = $('#pdp-selected-option');
  const $colorLabel    = $('#pdp-selected-color');
  const $thumbsList    = $('#pdp-thumbs-list');
  const variantData    = JSON.parse($('[data-variant-json]').text() || '[]');
  const variantFromUrl = new URLSearchParams(window.location.search).get('variant');
  const isSingleColorOption = $optionItems.length > 0 && $optionItems.length === $variantCards.length;

  function updateLabels(variantId) {
    const match = variantData.find(v => v.id == parseInt(variantId));
    if (!match) return;
    if ($selectedLabel.length) {
      const labelText = (match.option1 && match.option2)
        ? match.option1 + ' (' + match.option2 + ')'
        : (match.option1 || '');
      $selectedLabel.text(labelText);
    }
    if ($colorLabel.length) $colorLabel.text(match.option1);
  }

  function showAllCards() {
    $variantCards.show().removeClass('active');
  }

  function activateCard($card, $input) {
    $card.addClass('active');
    $input.prop('checked', true).trigger('change');
  }

  function scrollSwiperToActive() {
    if (!window.pdpVariantsSwiper) return;
    const $activeSlide = $('.pdp-variant-slide:has(.pdp-variant-card.active)');
    if ($activeSlide.length) {
      const index = $('.pdp-variant-slide').index($activeSlide);
      if (index > -1) window.pdpVariantsSwiper.slideTo(index, 300);
    }
  }

  function updateUrl(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }

  function filterVariants(selectedOption) {
    let $firstVisible = null;
    $variantCards.each(function () {
      const match = $(this).attr('data-option') === selectedOption;
      $(this).toggle(match);
      if (match && !$firstVisible && !$(this).hasClass('disabled')) $firstVisible = $(this);
    });
    if (!$firstVisible) return;
    $variantCards.removeClass('active');
    const $input = $firstVisible.find('input');
    activateCard($firstVisible, $input);
    if (window.pdpVariantsSwiper) {
      window.pdpVariantsSwiper.slideTo(0, 0);
      // ADD THESE TWO LINES:
      window.pdpVariantsSwiper.update();
      window.pdpVariantsSwiper.updateSlidesClasses();
    }
    updateLabels($input.val());
    updateCartPrice($firstVisible);
    //setTimeout(() => switchGalleryToVariant($input.val()), 100);
  }

  // ===== VARIANT FROM URL =====
  if (variantFromUrl) {
    const $targetInput = $(`input[name="id"][value="${variantFromUrl}"]`);
    if ($targetInput.length) {
      const $card = $targetInput.closest('.pdp-variant-card');
      const optionValue = $card.attr('data-option');

      if (isSingleColorOption) {
        showAllCards();
        $optionItems.each(function () {
          $(this).toggleClass('active', $(this).attr('data-value') === optionValue);
        });
      } else if ($optionItems.length > 0) {
        $optionItems.each(function () {
          $(this).toggleClass('active',
            $(this).attr('data-value') === optionValue || $(this).text().trim() === optionValue
          );
        });
        filterVariants(optionValue);
        $variantCards.removeClass('active');
      } else {
        showAllCards();
      }

      activateCard($card, $targetInput);
      updateLabels(variantFromUrl);
      updateCartPrice($card);
      setTimeout(() => switchGalleryToVariant(variantFromUrl), 500);
      setTimeout(scrollSwiperToActive, 600);
    }
  }

  // ===== INIT DEFAULT =====
  const defaultOption = $('.pdp-option-item.active').attr('data-value')
                     || $('.pdp-option-item.active').text().trim();

  if (!variantFromUrl && defaultOption) {
    if (isSingleColorOption) {
      showAllCards();
      // Find card matching the active option item, not just first card
      const activeOptionValue = $('.pdp-option-item.active').attr('data-value');
      let $firstAvailable = $variantCards.filter('[data-option="' + activeOptionValue + '"]').first();
      if (!$firstAvailable.length) $firstAvailable = $variantCards.not('.disabled').first();
      if ($firstAvailable.length) {
        $variantCards.removeClass('active');
        const $input = $firstAvailable.find('input');
        activateCard($firstAvailable, $input);
        updateLabels($input.val());
        updateCartPrice($firstAvailable);
        //setTimeout(() => switchGalleryToVariant($input.val()), 300);
      }
    }
     else {
      filterVariants(defaultOption);
      
    }
  } else if (!variantFromUrl && $optionItems.length === 0) {
    showAllCards();
    const $firstAvailable = $variantCards.not('.disabled').first();
    if ($firstAvailable.length) {
      $variantCards.removeClass('active');
      const $input = $firstAvailable.find('input');
      activateCard($firstAvailable, $input);
      updateLabels($input.val());
      updateCartPrice($firstAvailable);
      //setTimeout(() => switchGalleryToVariant($input.val()), 300);
    }
  }

  // ===== OPTION ITEM CLICK =====
  $(document).on('click', '.pdp-option-item', function () {
    if ($(this).hasClass('unavailable')) return;
    $optionItems.removeClass('active');
    $(this).addClass('active');
    const value = $(this).attr('data-value') || $(this).text().trim();

    if (isSingleColorOption) {
      showAllCards();
      const $matchCard = $variantCards.filter(`[data-option="${value}"]`).first();
      if ($matchCard.length) {
        const $input = $matchCard.find('input');
        activateCard($matchCard, $input);
        updateLabels($input.val());
        updateUrl($input.val());
        switchGalleryToVariant($input.val());

        setTimeout(() => {
          const $matchSlide = $matchCard.closest('.pdp-variant-slide');
          if ($matchSlide.length && window.pdpVariantsSwiper) {
            const swiper     = window.pdpVariantsSwiper;
            const scrollTo   = $matchSlide[0].offsetLeft - (swiper.width / 2) + ($matchSlide[0].offsetWidth / 2);
            const translate  = Math.max(swiper.maxTranslate(), Math.min(swiper.minTranslate(), -scrollTo));
            swiper.setTranslate(translate);
            swiper.updateProgress();
            swiper.updateSlidesClasses();
          }
          // ADD THIS:
          if (window.pdpVariantsSwiper) {
            window.pdpVariantsSwiper.update();
          }
        }, 50);
      }
    } else {
      filterVariants(value);
    }
  });

  // ===== VARIANT CARD CLICK =====
  $(document).on('click', '.pdp-variant-card', function () {
    $variantCards.removeClass('active');
    const $input     = $(this).find('input');
    const $atcBtn    = $('.pdp-add-cart');
    const $notifyBtn = $('.pdp-notify-btn');

    $(this).addClass('active');
    $input.prop('checked', true).trigger('change');
    updateLabels($input.val());
    updateUrl($input.val());
    switchGalleryToVariant($input.val());
    updateCartPrice($(this));

    if ($(this).hasClass('disabled')) {
      $atcBtn.hide().prop('disabled', true);
      $notifyBtn.show();
      //$('#pdp-edt-badge').addClass('is-hidden');
      //$('.PDP_dtl_response').hide();
      //$('.pdp_store_widget').hide();
    } else {
      $atcBtn.show().prop('disabled', false);
      $notifyBtn.hide();
      //$('#pdp-edt-badge').removeClass('is-hidden');
      //$('.PDP_dtl_response').show();
      //$('.pdp_store_widget').show();
    }
  });

  // ===== INIT NOTIFY STATE on page load =====
  (function () {
      const $atcBtn    = $('.pdp-add-cart');
      const $notifyBtn = $('.pdp-notify-btn');

      // Case 1: product has variant cards (multi-variant)
      if ($variantCards.length > 0) {
        setTimeout(function() {
          var variantData = JSON.parse($('[data-variant-json]').text() || '[]');
          var checkedId   = $('input[name="id"]:checked').val();
          var match       = variantData.find(function(v) { return v.id == parseInt(checkedId); });
          var isAvailable = match ? match.available : false;

          if (!isAvailable) {
            $atcBtn.hide().prop('disabled', true);
            $notifyBtn[0].style.setProperty('display', 'flex', 'important');
          } else {
            $atcBtn.show().prop('disabled', false);
            $notifyBtn[0].style.setProperty('display', 'none', 'important');
          }
        }, 800);
      } else {
        // Case 2: single variant — no variant cards exist
        // Check if the ATC button itself is disabled (set by Liquid)
       if ($atcBtn.prop('disabled') || $atcBtn.attr('disabled') !== undefined) {
          $atcBtn.hide();
          $notifyBtn.show();
        } else {
          $atcBtn.show().prop('disabled', false);
          $notifyBtn.hide();
        }
      }
    })();

  // ===== OFFERS DRAWER =====
  function toggleOffers(open) {
    $('#pdp-offers-drawer').toggleClass('active', open);
    $('body').css('overflow', open ? 'hidden' : '');
  }
  $('#pdp-offers-trigger').on('click', () => toggleOffers(true));
  $('#pdp-offers-close, #pdp-offers-close-mobile').on('click', () => toggleOffers(false));
  $('#pdp-offers-overlay').on('click', () => toggleOffers(false));

  // ===== COPY COUPON =====
  $(document).on('click', '.pdp-offer-copy-btn', function () {
    const code = $(this).attr('data-code');
    const $btn = $(this);
    navigator.clipboard.writeText(code).then(() => {
      $btn.text('Copied!');
      setTimeout(() => $btn.text('Copy'), 2000);
    });
  });

  // ===== GALLERY SWIPER =====
  let gallerySwiper = null;

  function initGallerySwiper() {
    if (typeof Swiper === 'undefined') return setTimeout(initGallerySwiper, 300);
    const isMobile = window.innerWidth <= 767;

    gallerySwiper = new Swiper('.pdp-gallery-swiper', {
      slidesPerView: isMobile ? 'auto' : 1,
      effect: isMobile ? 'slide' : 'fade',
      fadeEffect: { crossFade: true },
      spaceBetween: isMobile ? 12 : 0,
      centeredSlides: false,       
      slideToClickedSlide: true,
      navigation: { nextEl: '.pdp-gallery-next', prevEl: '.pdp-gallery-prev' },
      pagination: { el: '.pdp-gallery-pagination', clickable: true },
      on: { slideChange() { updateActiveThumbnail(this.activeIndex); } }
    });

    
  }
  initGallerySwiper();

  function updateDynamicBullets(activeIndex) {
    $('.pdp-gallery-pagination .swiper-pagination-bullet').each(function(i) {
      var diff = Math.abs(i - activeIndex);
      $(this).removeClass('bull-0 bull-1 bull-2 bull-far');
      if      (diff === 0) $(this).addClass('bull-0');
      else if (diff === 1) $(this).addClass('bull-1');
      else if (diff === 2) $(this).addClass('bull-2');
      else                 $(this).addClass('bull-far');
    });
  }

  // Hook into swiper
  gallerySwiper.on('slideChange', function() {
    updateDynamicBullets(this.activeIndex);
  });

  // Init on load
  gallerySwiper.on('init', function() {
    updateDynamicBullets(this.activeIndex);
  });
  updateDynamicBullets(gallerySwiper.activeIndex);

  // ===== USP + VARIANTS SWIPER =====
  if (typeof Swiper !== 'undefined') {
    new Swiper('.pdp-usps-swiper', {
      slidesPerView: 'auto', watchOverflow: true, spaceBetween: 8, freeMode: true,
      navigation: { nextEl: '.pdp-usp-next', prevEl: '.pdp-usp-prev' }
    });
    window.pdpVariantsSwiper = new Swiper('.pdp-variants-swiper', {
      slidesPerView: 'auto', freeMode: true,watchOverflow: true,
      slidesOffsetAfter: window.innerWidth <= 767 ? 24 : 0,
      navigation: { nextEl: '.pdp-variants-next', prevEl: '.pdp-variants-prev' }
    });
  }

  // ===== THUMBNAIL CLICK =====
  $(document).on('click', '.pdp-thumb-item', function () {
    gallerySwiper?.slideTo(parseInt($(this).attr('data-index')));
  });

  function updateActiveThumbnail(activeIndex) {
    $('.pdp-thumb-item').each(function (i) {
      $(this).toggleClass('active', i === activeIndex);
    });
    const $activeThumb = $('.pdp-thumb-item.active');
    if ($activeThumb.length && $thumbsList.length) {
      $thumbsList[0].scrollTo({
        top:  $activeThumb[0].offsetTop  - ($thumbsList[0].offsetHeight / 2) + ($activeThumb[0].offsetHeight / 2),
        left: $activeThumb[0].offsetLeft - ($thumbsList[0].offsetWidth  / 2) + ($activeThumb[0].offsetWidth  / 2),
        behavior: 'smooth'
      });
    }
  }

  // ===== SWITCH GALLERY TO VARIANT =====
  function switchGalleryToVariant(variantId) {
    const mapEl = $('[data-media-map]');
    if (!mapEl.length || !gallerySwiper) return;
    const mediaId = JSON.parse(mapEl.text())[variantId];
    if (!mediaId || mediaId === 'undefined') return;
    $('.pdp-gallery-slide').each(function (i) {
      if ($(this).attr('data-media-id') === mediaId) gallerySwiper.slideTo(i);
    });
  }

  // ===== VIDEO PLAY =====
  $(document).on('click', '.pdp-play-btn', function () {
    const $wrap  = $(this).closest('.pdp-slide-video-wrap');
    const $video = $wrap.find('.pdp-inline-video');
    if (!$video.length) return;
    $wrap.find('.pdp-video-poster').hide();
    $(this).hide();
    $video.show()[0].play();
  });

  // ===== SHARE =====
  $(document).on('click', '.pdp-share-btn', function () {
    const url   = $(this).attr('data-url');
    const title = $(this).attr('data-title');
    const $btn  = $(this);
    if (navigator.share) {
      navigator.share({ title, url }).catch(() => {});
    } else {
      navigator.clipboard.writeText(url).then(() => {
        $btn.addClass('pdp-share-copied');
        setTimeout(() => $btn.removeClass('pdp-share-copied'), 2000);
      });
    }
  });

  // ===== SIZE CHART =====
  function toggleSizeChart(open) {
    $('#pdp-sizechart-popup').toggleClass('active', open);
    $('#pdp-sizechart-overlay').toggleClass('active', open);
    $('body').css('overflow', open ? 'hidden' : '');
  }
  $('#pdp-size-chart-trigger').on('click', () => toggleSizeChart(true));
  $('#pdp-sizechart-close').on('click', () => toggleSizeChart(false));
  $('#pdp-sizechart-overlay').on('click', () => toggleSizeChart(false));

  // ===== VRT + RATING SWIPERS =====
  new Swiper('.vrt-related-products.swiper-container', {
    slidesPerView: 'auto', freeMode: true, watchOverflow: true,
    slidesOffsetAfter: window.innerWidth <= 767 ? 30 : 0,
    navigation: { nextEl: '.vrt-next', prevEl: '.vrt-prev' }
  });
  new Swiper('.pdp-ratingstats-swiper', {
    slidesPerView: 'auto', spaceBetween: 8, freeMode: true, grabCursor: true,centerInsufficientSlides: true,
    pagination: { el: '.pdp-ratingstats-pagination', clickable: true }
  });

  // ===== COLOR SWATCH FALLBACK =====
  $('.pdp-color-circle').each(function () {
    const $circle  = $(this);
    const $parent  = $circle.closest('.pdp-option-color');
    const testEl   = document.createElement('div');
    testEl.style.backgroundColor = $circle[0].style.backgroundColor;

    if (testEl.style.backgroundColor === '' || testEl.style.backgroundColor === 'transparent') {
      const imgUrl = $parent.attr('data-img');
      if (imgUrl) {
        $circle.css({
          'background-image'   : `url(${imgUrl})`,
          'background-color'   : 'transparent',
          'background-size'    : 'cover',
          'background-position': 'center'
        });
      }
    }
  });

  // ===== WISHLIST =====

  function applyWishlistState(inWishlist) {
  document.querySelectorAll('.wishlist_icon[data-wishlistid]').forEach(el => {
    el.classList.toggle('WHL_removeBtn', inWishlist);
    el.classList.toggle('WHL_addBtn', !inWishlist);
  });
  document.querySelectorAll('.pdp_wishlist').forEach(el => {
    el.classList.toggle('WHL_removeBtnhrt', inWishlist);
  });
  }

  function checkWishlistAndSync() {
    const productId = document.querySelector('[data-wishlistid]')?.getAttribute('data-wishlistid');
    const mobile = (collection_wishlist.toString().match(/mobile=(\d+)/) || [])[1];
    const token = (collection_wishlist.toString().match(/huft-api-access-token["']?\s*:\s*["']([^"']+)/) || [])[1];
    if (!productId || !mobile || !token) return;

    $.ajax({
      url: 'https://api.headsupfortails.com/v1/cart/wishlist/check-is-wishlist?mobile=' + mobile + '&product_id=gid://shopify/Product/' + productId,
      method: 'GET',
      headers: { 'huft-api-access-token': token },
      success: function(response) {
        applyWishlistState(response?.data?.is_product_wishlist === true);
      }
    });
  }

  // On page load sync
  try { checkWishlistAndSync(); } catch(e) {}

  // On click — let updateProductWishlist run, then re-sync after it finishes
  document.addEventListener('click', function(e) {
  if (!e.target.closest('.wishlist_icon[data-wishlistid]')) return;

  const $clicked     = $(e.target).closest('.wishlist_icon');
  const isInWishlist = $clicked.hasClass('WHL_removeBtn');
  const tooltipText  = isInWishlist ? 'Removed from Wishlist' : 'Added to Wishlist';

  const $tooltip = $clicked.closest('.pdp_wishlist').find('.wishlist_tooltip');

  if ($tooltip.length) {
    $tooltip.find('.w_tip_inner').text(tooltipText);
    $tooltip.show();
    clearTimeout(window._wishlistTooltipTimer);
    window._wishlistTooltipTimer = setTimeout(() => $tooltip.hide(), 2000);
  }

  setTimeout(checkWishlistAndSync, 600);
  });
  // ===== ADDITIONAL INFO UPDATE  =====
  function updateAdditionalInfo(variantId) {

    const match = variantData.find(v => v.id == parseInt(variantId));
    if (!match) return;

    // 1) Weight — read data-net-qty from input
    const $input = $('input[name="id"][value="' + variantId + '"]');
    const netQty = $input.attr('data-net-qty');
    if (netQty) $('#adweight').text(netQty);

    // 2) MRP — from variantData JSON
    const comparePrice = match.compare_at_price;
    const price        = match.price;
    const mrp          = comparePrice > price ? comparePrice : price;
    const formatted    = '₹' + (mrp / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    $('#final_price').text(formatted);

    // 3) Discount
    if (comparePrice > price) {
      const discount = Math.round((comparePrice - price) / comparePrice * 100);
      $('.pdp-additional-discount').text(discount + '%');
      $('.pdp-additional-discount-row').show();
    } else {
      $('.pdp-additional-discount-row').hide();
    }
  }

  // ===== ORDER WITHIN COUNTDOWN (cutoff 4PM) =====
 /* function updateOrderWithin() {
    const $row   = $('.PDP_dtl_timeOuter');
    const $hours = $('.PDP_dtl_hours');
    if (!$row.length) return;

    const now    = new Date();
    const cutoff = new Date();
    cutoff.setHours(19, 0, 0, 0); // 6:00 PM today

    const diffMs = cutoff - now;
    if (diffMs < 0) {
      $row.hide();
      return;
    }

    const totalMins  = Math.floor(diffMs / 60000);
    const hoursLeft  = Math.floor(totalMins / 60);
    const minsLeft   = totalMins % 60;

    let label = '';
    if (hoursLeft > 0 && minsLeft > 0) {
      label = hoursLeft + 'h ' + minsLeft + 'min';
    } else if (hoursLeft > 0) {
      label = hoursLeft + 'h';
    } else {
      label = minsLeft + 'min';
    }

    $hours.text(label);
    $row.show();
  }*/

  // Run immediately
  //updateOrderWithin();

  // Update every minute
  //setInterval(updateOrderWithin, 60000);

  // ===== CART PRICE UPDATE =====
  function updateCartPrice($card) {
    if (!$card || !$card.length) return;
    const raw     = v => parseInt((v || '0').replace(/[^0-9]/g, '')) || 0;
    const price   = raw($card.attr('data-vprice'));
    const compare = raw($card.attr('data-vcmprice'));
    const fmt     = v => '₹' + (v / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    if (!price) return; // nothing to show

    if (compare > 0 && compare > price) {
      const disc = Math.round((compare - price) / compare * 100);
      $('#pdp-cp-rate').html(
        `<div class="pdp-cprp">${fmt(price)}</div>` +
        `<div class="pdp-pr">` +
          `<div class="pdp-cprcp"><span class="pdp-mrp-label">MRP</span> ${fmt(compare)}</div>` +
          `<div class="pdp-cprd">(${disc}% OFF)</div>` +
        `</div>`
      );
    } else {
      $('#pdp-cp-rate').html(
        `<div class="pdp-cprp"><span class="pdp-mrp-label">MRP</span> ${fmt(price)}</div>`
      );
    }
  }
  
  // ===== LISTEN TO INPUT CHANGE =====
  $(document).on('change', 'input[name="id"]', function () {
    updateAdditionalInfo($(this).val());

  });

  // Init on page load
  const $defaultInput = $('input[name="id"]:checked').first();
  if ($defaultInput.length) updateAdditionalInfo($defaultInput.val());

  // Single variant price
  if ($('.pdp-variant-card').length === 0) {
   
    const $pdpInput = $('.pdp-form input[name="id"]').first();
    const price   = parseInt($pdpInput.attr('data-vprice'))   || 0;
    const compare = parseInt($pdpInput.attr('data-vcmprice')) || 0;
    if (price) {
      const fmt = v => '₹' + (v / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      if (compare && compare > price) {
        const disc = Math.round((compare - price) / compare * 100);
        $('#pdp-cp-rate').html(`<div class="pdp-cprp">${fmt(price)}</div><div class="pdp-pr"><div class="pdp-cprcp"><span class="pdp-mrp-label">MRP</span> ${fmt(compare)}</div><div class="pdp-cprd">(${disc}% OFF)</div></div>`);
      } else {
        $('#pdp-cp-rate').html(`<div class="pdp-cprp"><span class="pdp-mrp-label">MRP</span> ${fmt(price)}</div>`);
      }
    }
  }

  var fontStyleInterval = setInterval(function() {
    var found = false;
    $('.bold_option_swatch').each(function() {
      var $title = $(this).find('.bold_option_title');
      if ($title.text().trim().includes('Font Style')) {
        $(this).addClass('font-style-swatch');
        found = true;
      }
    });
    if (found) clearInterval(fontStyleInterval);
  }, 300);

  setTimeout(function() {
    clearInterval(fontStyleInterval);
  }, 10000);

  // Open modal and scroll to clicked image
  document.querySelectorAll('.pdp-media-zoom').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var mediaId = this.getAttribute('data-media-id');
      var modal = document.getElementById('ProductModal-pdpv2');
      if (!modal) return;

      // open
      modal.removeAttribute('hidden');
      modal.setAttribute('open', '');
      document.body.style.overflow = 'hidden';

      // scroll to the right image
      var target = modal.querySelector('[data-media-id="' + mediaId + '"]');
      if (target) {
        setTimeout(function() {
          target.scrollIntoView({ block: 'start' });
        }, 50);
      }
    });
  });

  // Close on X button
  document.addEventListener('click', function(e) {
    if (e.target.closest('#ModalClose-pdpv2')) {
      closeModal();
    }
  });

  // Close on backdrop click
  var modal = document.getElementById('ProductModal-pdpv2');
  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });
  }

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  function closeModal() {
    var modal = document.getElementById('ProductModal-pdpv2');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    modal.removeAttribute('open');
    document.body.style.overflow = '';
  }

});